/**
 * Cấu hình tiến trình & trạng thái của ứng viên trong Quản lý hồ sơ CV (recruitment-cvs)
 */

export const HR_CAN_DUYET = 0;
export const HR_TU_CHOI = 1;
export const TEAM_LEAD_CAN_DUYET = 2;
export const TEAM_LEAD_DA_DUYET = 3;
export const TEAM_LEAD_TU_CHOI = 4;
export const PHONG_VAN_V1 = 5;
export const HUY_PHONG_VAN_V1 = 6;
export const DA_NHAP_KET_QUA_PHONG_VAN_V1_PASS = 7;
export const DA_NHAP_KET_QUA_PHONG_VAN_V1_FAIL = 8;
export const PHONG_VAN_V2 = 9;
export const HUY_PHONG_VAN_V2 = 10;
export const DA_NHAP_KET_QUA_PHONG_VAN_V2_PASS = 11;
export const DA_NHAP_KET_QUA_PHONG_VAN_V2_FAIL = 12;
export const CAN_DIEN_OFFER = 13;
export const CAN_LAM_THU_TUC_PASS = 14;
export const UNG_VIEN_KHONG_DI_LAM = 15;
export const DA_GUI_DAO_TAO_HOI_NHAP = 16;
export const DA_DAO_TAO_HOI_NHAP_PASS = 17;
export const CAN_XEP_LOP = 18;
export const DA_XEP_LOP = 19;
export const QC_THANH_TRA_THU_VIEC_PASS = 20;
export const QC_THANH_TRA_THU_VIEC_FAIL = 21;
export const CAN_DANH_GIA_THU_VIEC = 22;
export const DA_NHAP_KET_QUA_DANH_GIA_THU_VIEC_PASS = 23;
export const DA_NHAP_KET_QUA_DANH_GIA_THU_VIEC_FAIL = 24;
export const DA_NHAN_VIEC = 25;

export const STATUS_TEXT = {
    [HR_CAN_DUYET]: "HR cần duyệt",
    [HR_TU_CHOI]: "HR từ chối",
    [TEAM_LEAD_CAN_DUYET]: "Team lead cần duyệt",
    [TEAM_LEAD_DA_DUYET]: "Team lead đã duyệt",
    [TEAM_LEAD_TU_CHOI]: "Team lead từ chối",
    [PHONG_VAN_V1]: "Phỏng vấn V1",
    [HUY_PHONG_VAN_V1]: "Hủy phỏng vấn V1",
    [DA_NHAP_KET_QUA_PHONG_VAN_V1_PASS]: "Đã nhập kết quả phỏng vấn V1 - Pass",
    [DA_NHAP_KET_QUA_PHONG_VAN_V1_FAIL]: "Đã nhập kết quả phỏng vấn V1 - Fail",
    [PHONG_VAN_V2]: "Phỏng vấn V2",
    [HUY_PHONG_VAN_V2]: "Hủy phỏng vấn V2",
    [DA_NHAP_KET_QUA_PHONG_VAN_V2_PASS]: "Đã nhập kết quả phỏng vấn V2 - Pass",
    [DA_NHAP_KET_QUA_PHONG_VAN_V2_FAIL]: "Đã nhập kết quả phỏng vấn V2 - Fail",
    [CAN_DIEN_OFFER]: "Cần điền offer",
    [CAN_LAM_THU_TUC_PASS]: "Cần làm thủ tục Pass",
    [UNG_VIEN_KHONG_DI_LAM]: "Ứng viên không đi làm",
    [DA_GUI_DAO_TAO_HOI_NHAP]: "Đã gửi đào tạo hội nhập",
    [DA_DAO_TAO_HOI_NHAP_PASS]: "Đã đào tạo hội nhập - Pass",
    [CAN_XEP_LOP]: "Cần xếp lớp",
    [DA_XEP_LOP]: "Đã xếp lớp",
    [QC_THANH_TRA_THU_VIEC_PASS]: "QC thanh tra thử việc - Pass",
    [QC_THANH_TRA_THU_VIEC_FAIL]: "QC thanh tra thử việc - Fail",
    [CAN_DANH_GIA_THU_VIEC]: "Cần đánh giá thử việc",
    [DA_NHAP_KET_QUA_DANH_GIA_THU_VIEC_PASS]: "Đã nhập kết quả đánh giá thử việc - Pass",
    [DA_NHAP_KET_QUA_DANH_GIA_THU_VIEC_FAIL]: "Đã nhập kết quả đánh giá thử việc - Fail",
    [DA_NHAN_VIEC]: "Đã nhận việc",
};

/**
 * Danh sách toàn bộ các tiến trình/trạng thái của ứng viên (hiển thị phẳng, không gom nhóm)
 */
export const CANDIDATE_STAGES = Object.keys(STATUS_TEXT).map((key) => {
    const num = Number(key);
    return {
        key: `status_${num}`,
        status: num,
        label: STATUS_TEXT[num] || `Trạng thái #${num}`,
        statuses: [num],
    };
});

/**
 * Metadata hiển thị cho từng trạng thái: màu sắc, loại tag, biểu tượng, kết quả (pass/fail/pending/cancelled)
 */
export const STATUS_META = {
    [HR_CAN_DUYET]: {
        label: "HR cần duyệt",
        short: "HR cần duyệt",
        color: "#d97706",
        bg: "#fef3c7",
        type: "warning",
        icon: "el-icon-time",
        stepIndex: 0,
        stageKey: "hr_review",
        isFail: false,
    },
    [HR_TU_CHOI]: {
        label: "HR từ chối",
        short: "HR từ chối",
        color: "#dc2626",
        bg: "#fee2e2",
        type: "danger",
        icon: "el-icon-close",
        stepIndex: 0,
        stageKey: "hr_review",
        isFail: true,
    },
    [TEAM_LEAD_CAN_DUYET]: {
        label: "Team lead cần duyệt",
        short: "TL cần duyệt",
        color: "#2563eb",
        bg: "#dbeafe",
        type: "primary",
        icon: "el-icon-user",
        stepIndex: 1,
        stageKey: "team_lead_review",
        isFail: false,
    },
    [TEAM_LEAD_DA_DUYET]: {
        label: "Team lead đã duyệt",
        short: "TL đã duyệt",
        color: "#059669",
        bg: "#d1fae5",
        type: "success",
        icon: "el-icon-check",
        stepIndex: 1,
        stageKey: "team_lead_review",
        isFail: false,
    },
    [TEAM_LEAD_TU_CHOI]: {
        label: "Team lead từ chối",
        short: "TL từ chối",
        color: "#dc2626",
        bg: "#fee2e2",
        type: "danger",
        icon: "el-icon-close",
        stepIndex: 1,
        stageKey: "team_lead_review",
        isFail: true,
    },
    [PHONG_VAN_V1]: {
        label: "Phỏng vấn V1",
        short: "PV V1",
        color: "#4f46e5",
        bg: "#eef2ff",
        type: "",
        icon: "el-icon-chat-dot-round",
        stepIndex: 2,
        stageKey: "interview_v1",
        isFail: false,
    },
    [HUY_PHONG_VAN_V1]: {
        label: "Hủy phỏng vấn V1",
        short: "Huỷ PV V1",
        color: "#64748b",
        bg: "#f1f5f9",
        type: "info",
        icon: "el-icon-circle-close",
        stepIndex: 2,
        stageKey: "interview_v1",
        isFail: true,
    },
    [DA_NHAP_KET_QUA_PHONG_VAN_V1_PASS]: {
        label: "Đã nhập kết quả phỏng vấn V1 - Pass",
        short: "PV V1 - Pass",
        color: "#059669",
        bg: "#d1fae5",
        type: "success",
        icon: "el-icon-circle-check",
        stepIndex: 2,
        stageKey: "interview_v1",
        isFail: false,
    },
    [DA_NHAP_KET_QUA_PHONG_VAN_V1_FAIL]: {
        label: "Đã nhập kết quả phỏng vấn V1 - Fail",
        short: "PV V1 - Fail",
        color: "#dc2626",
        bg: "#fee2e2",
        type: "danger",
        icon: "el-icon-circle-close",
        stepIndex: 2,
        stageKey: "interview_v1",
        isFail: true,
    },
    [PHONG_VAN_V2]: {
        label: "Phỏng vấn V2",
        short: "PV V2",
        color: "#7c3aed",
        bg: "#f3e8ff",
        type: "",
        icon: "el-icon-chat-line-square",
        stepIndex: 3,
        stageKey: "interview_v2",
        isFail: false,
    },
    [HUY_PHONG_VAN_V2]: {
        label: "Hủy phỏng vấn V2",
        short: "Huỷ PV V2",
        color: "#64748b",
        bg: "#f1f5f9",
        type: "info",
        icon: "el-icon-circle-close",
        stepIndex: 3,
        stageKey: "interview_v2",
        isFail: true,
    },
    [DA_NHAP_KET_QUA_PHONG_VAN_V2_PASS]: {
        label: "Đã nhập kết quả phỏng vấn V2 - Pass",
        short: "PV V2 - Pass",
        color: "#059669",
        bg: "#d1fae5",
        type: "success",
        icon: "el-icon-circle-check",
        stepIndex: 3,
        stageKey: "interview_v2",
        isFail: false,
    },
    [DA_NHAP_KET_QUA_PHONG_VAN_V2_FAIL]: {
        label: "Đã nhập kết quả phỏng vấn V2 - Fail",
        short: "PV V2 - Fail",
        color: "#dc2626",
        bg: "#fee2e2",
        type: "danger",
        icon: "el-icon-circle-close",
        stepIndex: 3,
        stageKey: "interview_v2",
        isFail: true,
    },
    [CAN_DIEN_OFFER]: {
        label: "Cần điền offer",
        short: "Cần điền offer",
        color: "#0284c7",
        bg: "#e0f2fe",
        type: "primary",
        icon: "el-icon-edit-outline",
        stepIndex: 4,
        stageKey: "offer_procedure",
        isFail: false,
    },
    [CAN_LAM_THU_TUC_PASS]: {
        label: "Cần làm thủ tục Pass",
        short: "Làm thủ tục Pass",
        color: "#0d9488",
        bg: "#ccfbf1",
        type: "success",
        icon: "el-icon-document-checked",
        stepIndex: 4,
        stageKey: "offer_procedure",
        isFail: false,
    },
    [UNG_VIEN_KHONG_DI_LAM]: {
        label: "Ứng viên không đi làm",
        short: "UV không đi làm",
        color: "#9333ea",
        bg: "#f3e8ff",
        type: "warning",
        icon: "el-icon-warning-outline",
        stepIndex: 4,
        stageKey: "offer_procedure",
        isFail: true,
    },
    [DA_GUI_DAO_TAO_HOI_NHAP]: {
        label: "Đã gửi đào tạo hội nhập",
        short: "Gửi ĐT hội nhập",
        color: "#d97706",
        bg: "#fef3c7",
        type: "warning",
        icon: "el-icon-reading",
        stepIndex: 5,
        stageKey: "training_class",
        isFail: false,
    },
    [DA_DAO_TAO_HOI_NHAP_PASS]: {
        label: "Đã đào tạo hội nhập - Pass",
        short: "ĐT hội nhập Pass",
        color: "#059669",
        bg: "#d1fae5",
        type: "success",
        icon: "el-icon-check",
        stepIndex: 5,
        stageKey: "training_class",
        isFail: false,
    },
    [CAN_XEP_LOP]: {
        label: "Cần xếp lớp",
        short: "Cần xếp lớp",
        color: "#0284c7",
        bg: "#e0f2fe",
        type: "primary",
        icon: "el-icon-notebook-1",
        stepIndex: 5,
        stageKey: "training_class",
        isFail: false,
    },
    [DA_XEP_LOP]: {
        label: "Đã xếp lớp",
        short: "Đã xếp lớp",
        color: "#059669",
        bg: "#d1fae5",
        type: "success",
        icon: "el-icon-finished",
        stepIndex: 5,
        stageKey: "training_class",
        isFail: false,
    },
    [QC_THANH_TRA_THU_VIEC_PASS]: {
        label: "QC thanh tra thử việc - Pass",
        short: "QC thanh tra Pass",
        color: "#059669",
        bg: "#d1fae5",
        type: "success",
        icon: "el-icon-circle-check",
        stepIndex: 6,
        stageKey: "probation_qc",
        isFail: false,
    },
    [QC_THANH_TRA_THU_VIEC_FAIL]: {
        label: "QC thanh tra thử việc - Fail",
        short: "QC thanh tra Fail",
        color: "#dc2626",
        bg: "#fee2e2",
        type: "danger",
        icon: "el-icon-circle-close",
        stepIndex: 6,
        stageKey: "probation_qc",
        isFail: true,
    },
    [CAN_DANH_GIA_THU_VIEC]: {
        label: "Cần đánh giá thử việc",
        short: "Cần ĐG thử việc",
        color: "#d97706",
        bg: "#fef3c7",
        type: "warning",
        icon: "el-icon-edit",
        stepIndex: 6,
        stageKey: "probation_qc",
        isFail: false,
    },
    [DA_NHAP_KET_QUA_DANH_GIA_THU_VIEC_PASS]: {
        label: "Đã nhập kết quả đánh giá thử việc - Pass",
        short: "ĐG thử việc Pass",
        color: "#059669",
        bg: "#d1fae5",
        type: "success",
        icon: "el-icon-circle-check",
        stepIndex: 6,
        stageKey: "probation_qc",
        isFail: false,
    },
    [DA_NHAP_KET_QUA_DANH_GIA_THU_VIEC_FAIL]: {
        label: "Đã nhập kết quả đánh giá thử việc - Fail",
        short: "ĐG thử việc Fail",
        color: "#dc2626",
        bg: "#fee2e2",
        type: "danger",
        icon: "el-icon-circle-close",
        stepIndex: 6,
        stageKey: "probation_qc",
        isFail: true,
    },
    [DA_NHAN_VIEC]: {
        label: "Đã nhận việc",
        short: "Đã nhận việc",
        color: "#059669",
        bg: "#d1fae5",
        type: "success",
        icon: "el-icon-trophy",
        stepIndex: 7,
        stageKey: "hired",
        isFail: false,
    },
};

/** Danh sách options cho Select dropdown */
export const STATUS_OPTIONS = Object.keys(STATUS_TEXT).map((val) => {
    const num = Number(val);
    const meta = STATUS_META[num] || {};
    return {
        value: num,
        label: STATUS_TEXT[num],
        short: meta.short || STATUS_TEXT[num],
        color: meta.color || "#64748b",
        bg: meta.bg || "#f1f5f9",
        type: meta.type || "",
        icon: meta.icon || "el-icon-info",
        isFail: !!meta.isFail,
        stageKey: meta.stageKey || "hr_review",
    };
});

/** Lấy thông tin meta của 1 status */
export function getStatusMeta(status) {
    const num = Number(status);
    return STATUS_META[num] || {
        label: STATUS_TEXT[num] || `Trạng thái #${num}`,
        short: STATUS_TEXT[num] || `#${num}`,
        color: "#64748b",
        bg: "#f1f5f9",
        type: "info",
        icon: "el-icon-info",
        stepIndex: 0,
        isFail: false,
    };
}

/** Lấy nhãn text của 1 status */
export function getStatusText(status) {
    const num = Number(status);
    return STATUS_TEXT[num] || (num !== undefined && num !== null && !isNaN(num) ? `Trạng thái #${num}` : "Chưa có");
}

/**
 * Chuẩn hoá response từ API cv-status thành map { [statusNum]: statusName }
 * Hỗ trợ các định dạng:
 * - { data: { "0": "HR cần duyệt", ... } }
 * - { "0": "HR cần duyệt", ... }
 * - [ { id: 0, name: "HR cần duyệt" }, ... ]
 * - [ { value: 0, label: "HR cần duyệt" }, ... ]
 */
export function parseCvStatusResponse(resData) {
    if (!resData) return null;
    let data = resData;
    if (resData.data !== undefined && resData.data !== null) {
        data = resData.data;
    }
    if (data && typeof data === "object" && data.status !== undefined && typeof data.status === "object" && !Array.isArray(data.status)) {
        data = data.status;
    }
    if (data && typeof data === "object" && data.cv_status !== undefined && typeof data.cv_status === "object") {
        data = data.cv_status;
    }

    const result = {};

    // Trường hợp 1: data là mảng các object: [ { id: 0, name: "HR cần duyệt" }, ... ]
    if (Array.isArray(data)) {
        data.forEach((item, idx) => {
            if (item === null || item === undefined) return;
            if (typeof item === "object") {
                const id = item.id !== undefined
                    ? item.id
                    : (item.value !== undefined
                        ? item.value
                        : (item.status !== undefined ? item.status : item.key));
                const label = item.name || item.label || item.title || item.text || item.status_name || item.value;
                if (id !== undefined && label !== undefined) {
                    result[Number(id)] = String(label).trim();
                }
            } else if (typeof item === "string") {
                result[idx] = item.trim();
            }
        });
    }
    // Trường hợp 2: data là dictionary key-value: { "0": "HR cần duyệt", "1": "HR từ chối", ... }
    else if (data && typeof data === "object") {
        Object.keys(data).forEach((key) => {
            const val = data[key];
            if (val === null || val === undefined) return;
            if (typeof val === "string" || typeof val === "number") {
                result[Number(key)] = String(val).trim();
            } else if (typeof val === "object") {
                const label = val.name || val.label || val.title || val.text || val.status_name || val.value;
                if (label) {
                    result[Number(key)] = String(label).trim();
                }
            }
        });
    }

    return Object.keys(result).length > 0 ? result : null;
}

/**
 * Cập nhật STATUS_TEXT, STATUS_META, CANDIDATE_STAGES, STATUS_OPTIONS từ dữ liệu API cv-status
 */
export function updateStatusTextFromApi(apiStatusMap) {
    if (!apiStatusMap || typeof apiStatusMap !== "object") return;

    Object.keys(apiStatusMap).forEach((key) => {
        const num = Number(key);
        const text = String(apiStatusMap[key]).trim();
        if (!text) return;

        STATUS_TEXT[num] = text;

        if (STATUS_META[num]) {
            STATUS_META[num].label = text;
        } else {
            STATUS_META[num] = {
                label: text,
                short: text,
                color: "#64748b",
                bg: "#f1f5f9",
                type: "",
                icon: "el-icon-info",
                stepIndex: num,
                stageKey: `stage_${num}`,
                isFail: /từ chối|fail|hủy/i.test(text),
            };
        }
    });

    // Cập nhật lại CANDIDATE_STAGES in-place để các component import mảng này tự cập nhật
    const newStages = Object.keys(STATUS_TEXT).map((key) => {
        const num = Number(key);
        return {
            key: `status_${num}`,
            status: num,
            label: STATUS_TEXT[num] || `Trạng thái #${num}`,
            statuses: [num],
        };
    });
    CANDIDATE_STAGES.length = 0;
    CANDIDATE_STAGES.push(...newStages);

    // Cập nhật lại STATUS_OPTIONS in-place
    const newOptions = Object.keys(STATUS_TEXT).map((val) => {
        const num = Number(val);
        const meta = STATUS_META[num] || {};
        return {
            value: num,
            label: STATUS_TEXT[num],
            short: meta.short || STATUS_TEXT[num],
            color: meta.color || "#64748b",
            bg: meta.bg || "#f1f5f9",
            type: meta.type || "",
            icon: meta.icon || "el-icon-info",
            isFail: !!meta.isFail,
            stageKey: meta.stageKey || "hr_review",
        };
    });
    STATUS_OPTIONS.length = 0;
    STATUS_OPTIONS.push(...newOptions);
}

